// Installs the game's font (Grandstander, SIL OFL — public/assets/fonts/) before the game starts:
// loads it so Phaser measures text with the real glyphs, rewrites every new Text that asks for
// the system font (gameFontRule.mjs), and gives the DOM panels (friends, chat, login) the same.
import Phaser from 'phaser';
import { GAME_FONT, resolveFamily } from './gameFontRule.mjs';

export function installGameFont({ timeoutMs = 2500 } = {}) {
  const css = document.createElement('style');
  css.textContent = `@font-face { font-family: "Grandstander"; src: url(/assets/fonts/Grandstander.ttf) format("truetype"); font-weight: 100 900; font-display: block; }
img.icon { height: 1.2em; width: auto; vertical-align: -0.25em; }
body, body input, body button, body textarea, body select, body div, body span { font-family: ${GAME_FONT} !important; }`;
  document.head.appendChild(css);

  const proto = Phaser.GameObjects.GameObjectFactory.prototype;
  const origText = proto.text;
  proto.text = function (x, y, t, style) {
    return origText.call(this, x, y, t, { ...(style ?? {}), fontFamily: resolveFamily(style?.fontFamily) });
  };

  // Not awaited (the build target has no top-level await): once the font lands, texts already
  // drawn (the first screen) are re-measured with it.
  const ready = Promise.all([document.fonts.load('16px "Grandstander"'), document.fonts.load('bold 16px "Grandstander"')]);
  return Promise.race([ready, new Promise((r) => setTimeout(r, timeoutMs))]).catch(() => {});
}

export function refreshTexts(game) {
  const visit = (list) => { for (const o of list) { if (o.refreshLayout) { o.refreshLayout(); continue; } if (o.type === 'Text') o.updateText(); if (o.list) visit(o.list); } };
  for (const s of game.scene.getScenes(true)) visit(s.children.list);
}
